// @flow

import auth from '../../../service/auth';
import fetchFromApiServer from '../../../service/index';

export function getLoginData(shareUrl){
  const raw = shareUrl == null ? '' : String(shareUrl);
  const encoded = raw === '' ? '' : encodeURIComponent(raw);
  var url = 'WMSDetail/GetSenderDetail?inputUrl=' + encoded;
  return {
      type:'GET_SENDER_DETAIL',
      payload:fetchFromApiServer("GET", url)
  }
}

export function verifyPhoneNumber(phoneNumber){
  var url = 'WMSDetail/generateotp';
  return {
    type:'VERIFY_PHONE_NUMBER',
    payload:fetchFromApiServer("POST", url, phoneNumber)
  }
}

export function verifyOTP(obj){
    var url = 'WMSDetail/validateotp';
    return {
        type:'VERIFY_OTP',
        payload:fetchFromApiServer("POST", url, obj)
    }
}

export function storeIsShare(isShare){
  
  return {
      type:'LOGIN_IS_SHARE',
      payload:isShare
  }
}

export function checkUserIsConnected(): Action {
  const token = auth.getToken();
  const user = auth.getUserInfo();
  const checkUserHasId = (obj: any) => obj && (obj.userId || false);
  //const isExpired = auth.isExpiredToken(token);
  // const isAuthenticated = checkUserHasId(user) ? true : false;

  if(token && 
    auth.isAuthenticated() && checkUserHasId(user))
  {
    return {
      type: 'CHECK_IF_USER_IS_LOGGEDIN',
      ...user,
      isAuthenticated: true,
    };
  }
  else{
    return {
      type: 'CHECK_IF_USER_IS_LOGGEDIN',
      ...user,
      isAuthenticated: false,
    };
  }
}